import { DialogActions, DialogTitle, styled } from "@mui/material";

export const StyledDialog = {
  Title: styled("h2")(({ theme }) => ({
    margin: -2,
  })),
  FullWidth: styled("div")(({ theme }) => ({
    width: "100%",
  })),
  MuiDialogTitle: styled(DialogTitle)(({ theme }) => ({
    fontFamily: "Roboto, sans-serif",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "default",
  })),
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "500px",
    marginTop: "10px",
    cursor: "default",
  })),
  Actions: styled(DialogActions)(({ theme }) => ({
    margin: 10,
  })),
  LoadingContainer: styled("div")(({ theme }) => ({
    marginBottom: "30px",
  })),
};
